import { render, staticRenderFns } from "./OrdersScheduleMealExport.vue?vue&type=template&id=fddb45cc&scoped=true"
import script from "./OrdersScheduleMealExport.vue?vue&type=script&lang=js"
export * from "./OrdersScheduleMealExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddb45cc",
  null
  
)

export default component.exports